import { Navigate, useSearchParams } from "react-router-dom";

/** /flights/booking (ללא id) → חיפוש טיסות ציבורי תחת vacation-packages */
export default function FlightsBookingRootRedirect() {
  const [sp] = useSearchParams();
  const merged = new URLSearchParams(sp.toString());
  merged.set("category", "flights");
  const q = merged.toString();
  return (
    <Navigate
      to={q ? `/vacation-packages?${q}` : "/vacation-packages?category=flights"}
      replace
    />
  );
}
